module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA9.56835892.jpg";